"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiCategoryRepo = createApiCategoryRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiCategoryRepo() {
    return {
        getAll,
    };
}
async function getAll() {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/categories`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
